import PropTypes from 'prop-types';

export function Dialog({ children, dialogId, isOpen = false }) {
  return (
    <dialog
      id={dialogId}
      open={isOpen}
      onClick={() => document.getElementById(dialogId).close()}
      className="bg-transparent p-0 backdrop:bg-indigo-500/10 backdrop:[transition:backdrop-filter_.5s_ease]"
    >
      <div
        className="rounded-xl bg-transparent text-gray-900 dark:text-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </dialog>
  );
}

Dialog.propTypes = {
  children: PropTypes.node,
  dialogId: PropTypes.string,
  isOpen: PropTypes.bool,
};
